import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export function UploadDatasetNotification({
    droppedRowCount = 0,
    database = null,
    errorTable = null,
    schema = null,
    id,
    onDismiss
}) {
    const { t } = useTranslation();

    const isRowDropped = droppedRowCount > 0;
    return (
        <Snackbar
            id={id}
            onDismiss={onDismiss}
            variant={SnackbarVariant.SUCCESS}
            autoHideEnabled={!isRowDropped}>
            <SnackbarMessage>
                {t('notifications:UploadDatasetSucceeded', {
                    count: droppedRowCount,
                    database,
                    schema,
                    errorTable
                })}
            </SnackbarMessage>
        </Snackbar>
    );
}

UploadDatasetNotification.propTypes = {
    database: PropTypes.string,
    droppedRowCount: PropTypes.number,
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    schema: PropTypes.string,
    errorTable: PropTypes.string
};
